import { render } from "./VerifyAccountClosingModal.vue?vue&type=template&id=8a079300"
import script from "./VerifyAccountClosingModal.vue?vue&type=script&lang=js"
export * from "./VerifyAccountClosingModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__